export default __webpack_public_path__ + "images/logo.svg?b8afd32fb0788ed1114798734ee97f3c";